import { useState } from 'react';
import PasswordInput from 'components/gruenland/atoms/input-password';
import { useFormat } from 'helpers/hooks/useFormat';
import AccountForm from '../../../account-atoms/account-form';

interface Props {
  deleteAccount?: (password: string) => Promise<{ success: boolean }>;
}

const DeleteAccountForm = ({ deleteAccount }: Props) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });
  const [data, setData] = useState({ password: '' });
  const [error, setError] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(false);
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const onDeleteAccount = async (form: React.FormEvent) => {
    form.preventDefault();
    if (
      confirm(
        formatMessage({
          id: 'account.deleteAccountMessage',
          defaultMessage: "Questa azione non può essere annullata e perderai l'accesso.",
        }),
      )
    ) {
      const deleteAccountState = await deleteAccount?.(data.password);
      if (!deleteAccountState?.success) {
        setError(true);
      }
    }
  };

  return (
    <AccountForm
      title={formatMessage({ id: 'account.delete', defaultMessage: 'Elimina account' })}
      subtitle={formatMessage({
        id: 'account.deleteAccountMessage',
        defaultMessage: "Questa azione non può essere annullata e perderai l'accesso.",
      })}
      defaultCTASection
      requiredLabelIsVisible
      ctaVariant="delete"
      onSubmit={onDeleteAccount}
    >
      <PasswordInput
        error={error ? formatMessage({ id: 'validation.email', defaultMessage: 'Email non valida.' }) : ''}
        name={'password'}
        onChange={handleChange}
        label="Password confirmation"
        required
      />
    </AccountForm>
  );
};

export default DeleteAccountForm;
